export const COUNTRY_INDEX: Record<number, string> = {
    2: "Austria",
    3: "Burkina Faso",
    4: "Switzerland",
    5: "Cuba",
    6: "Czech Rep.",
    7: "Guadeloupe",
    8: "Lithuania",
    9: "Moldova",
    10: "Mali",
    11: "Malawi",
    12: "Norway",
    13: "Oman",
    14: "Philippines",
    15: "Palestine",
    16: "Angola",
    17: "Bosnia and Herzegovina",
    18: "Belgium",
    19: "Burundi",
    20: "Estonia",
    21: "Finland",
    22: "Croatia",
    23: "Liechtenstein",
    24: "Montenegro",
    25: "Nigeria",
    26: "New Zealand",
    27: "Poland",
    28: "Senegal",
    29: "Tunisia",
    30: "Venezuela",
    31: "Congo",
    32: "Egypt",
    33: "Haiti",
    34: "Japan",
    35: "Saint Kitts and Nevis",
    36: "Niger",
    37: "Peru",
    38: "Portugal",
    39: "El Salvador",
    40: "Turkey",
    41: "Ukraine",
    42: "Uganda",
    43: "Wales",
    44: "Zambia",
    45: "Albania",
    46: "Argentina",
    47: "Azerbaijan",
    48: "Bahrain",
    49: "Congo DR",
    50: "Cote d'Ivoire",
    51: "China",
    52: "Costa Rica",
    53: "Faroe Islands",
    54: "Greece",
    55: "Guinea-Bissau",
    56: "Honduras",
    57: "Hungary",
    58: "Iraq",
    59: "Kenya",
    60: "Korea, Republic of",
    61: "Kazakhstan",
    62: "Liberia",
    63: "Malta",
    64: "Netherlands",
    65: "Northern Ireland",
    66: "Panama",
    67: "French Polynesia",
    68: "Paraguay",
    69: "Vietnam",
    70: "South Africa",
    71: "Bulgaria",
    72: "Brazil",
    73: "Belarus",
    74: "Central African Republic",
    75: "Cyprus",
    76: "Spain",
    77: "Grenada",
    78: "Korea DPR",
    79: "Luxembourg",
    80: "North Macedonia",
    81: "Serbia",
    82: "Saudi Arabia",
    83: "Solomon Islands",
    84: "Tanzania",
    85: "Uruguay",
    86: "United Arab Emirates",
    87: "Bolivia",
    88: "Chile",
    89: "France",
    90: "Gabon",
    91: "Guinea",
    92: "Iran",
    93: "Italy",
    94: "Jamaica",
    95: "Morocco",
    96: "Mozambique",
    97: "Rwanda",
    98: "Sweden",
    99: "Slovenia",
    100: "Sierra Leone",
    101: "Syria",
    102: "Scotland",
    103: "Turks and Caicos Islands",
    104: "Thailand",
    105: "Zimbabwe",
    106: "AN",
    107: "Benin",
    108: "Bermuda",
    109: "Canada",
    110: "Cameroon",
    111: "Colombia",
    112: "Algeria",
    113: "Ecuador",
    114: "Ghana",
    115: "Republic of Ireland",
    116: "Israel",
    117: "Lebanon",
    118: "Mexico",
    120: "Qatar",
    121: "Romania",
    122: "Sudan",
    123: "Slovakia",
    124: "San Marino",
    125: "Turkmenistan",
    126: "Trinidad and Tobago",
    127: "United States",
    128: "Andorra",
    129: "Armenia",
    130: "Australia",
    131: "Cape Verde",
    132: "Germany",
    133: "Denmark",
    134: "England",
    135: "Georgia",
    136: "Gambia",
    137: "Guatemala",
    138: "Iceland",
    139: "Jordan",
    140: "Kuwait",
    141: "Latvia",
    142: "Monaco",
    143: "Madagascar",
    144: "Namibia",
    145: "Russia",
    146: "Singapore",
    147: "Suriname",
    148: "Togo",
    149: "Uzbekistan",
    202: "Afghanistan",
    203: "Antigua and Barbuda",
    204: "Anguilla",
    209: "Antarctica",
    211: "American Samoa",
    214: "Aruba",
    215: "Aland Islands",
    218: "Barbados",
    219: "Bangladesh",
    226: "Saint Barthelemy",
    228: "Brunei Darussalam",
    231: "Bahamas",
    232: "Bhutan",
    233: "Bouvet Island",
    234: "Botswana",
    236: "Belize",
    238: "Cocos (Keeling) Islands",
    244: "Cook Islands",
    252: "Christmas Island",
    256: "Djibouti",
    258: "Dominica",
    259: "Dominican Republic",
    264: "Western Sahara",
    265: "Eritrea",
    267: "Ethiopia",
    269: "Fiji",
    270: "Falkland Islands (Malvinas)",
    271: "Micronesia, Federated States of",
    275: "United Kingdom",
    278: "French Guiana",
    279: "Guernsey",
    281: "Gibraltar",
    282: "Greenland",
    286: "Equatorial Guinea",
    288: "South Georgia and the South Sandwich Islands",
    290: "Guam",
    292: "Guyana",
    293: "Hong Kong",
    294: "Heard Island and McDonald Islands",
    299: "Indonesia",
    302: "Isle of Man",
    303: "India",
    304: "British Indian Ocean Territory",
    309: "Jersey",
    314: "Kyrgyzstan",
    315: "Cambodia",
    316: "Kiribati",
    317: "Comoros",
    322: "Cayman Islands",
    326: "Saint Lucia",
    328: "Sri Lanka",
    330: "Lesotho",
    334: "Libya",
    339: "Saint Martin (French part)",
    341: "Marshall Islands",
    344: "Myanmar",
    345: "Mongolia",
    346: "Macao",
    347: "Northern Mariana Islands",
    348: "Martinique",
    349: "Mauritania",
    350: "Montserrat",
    352: "Mauritius",
    353: "Maldives",
    356: "Malaysia",
    359: "New Caledonia",
    361: "Norfolk Island",
    363: "Nicaragua",
    366: "Nepal",
    367: "Nauru",
    368: "Niue",
    374: "Papua New Guinea",
    376: "Pakistan",
    378: "Saint Pierre and Miquelon",
    379: "Pitcairn",
    380: "Puerto Rico",
    383: "Palau",
    386: "Réunion",
    393: "Seychelles",
    397: "Saint Helena",
    399: "Svalbard and Jan Mayen",
    404: "Somalia",
    406: "Sao Tome and Principe",
    409: "Swaziland",
    411: "Chad",
    412: "French Southern Territories",
    415: "Tajikistan",
    416: "Tokelau",
    417: "Timor-Leste",
    420: "Tonga",
    423: "Tuvalu",
    424: "Taiwan, Province of China",
    428: "United States Minor Outlying Islands",
    432: "Holy See (Vatican City State)",
    433: "Saint Vincent and the Grenadines",
    435: "Virgin Islands, British",
    436: "Virgin Islands, U.S.",
    438: "Vanuatu",
    439: "Wallis and Futuna",
    440: "Samoa",
    441: "Yemen",
    442: "Mayotte",
    444: "Netherlands Antilles",
    446: "Soviet Union",
    447: "CSSR",
    448: "Yugoslavia",
    450: "Fantasy League",
    452: "DDR",
    455: "Tahiti",
    457: "Kosovo",
    461: "Curaçao",
    462: "South Sudan",
}
export const COUNTRY_INDEX: Record<number, string> = {
    2: "Austria",
    3: "Burkina Faso",
    4: "Switzerland",
    5: "Cuba",
    6: "Czech Rep.",
    7: "Guadeloupe",
    8: "Lithuania",
    9: "Moldova",
    10: "Mali",
    11: "Malawi",
    12: "Norway",
    13: "Oman",
    14: "Philippines",
    15: "Palestine",
    16: "Angola",
    17: "Bosnia and Herzegovina",
    18: "Belgium",
    19: "Burundi",
    20: "Estonia",
    21: "Finland",
    22: "Croatia",
    23: "Liechtenstein",
    24: "Montenegro",
    25: "Nigeria",
    26: "New Zealand",
    27: "Poland",
    28: "Senegal",
    29: "Tunisia",
    30: "Venezuela",
    31: "Congo",
    32: "Egypt",
    33: "Haiti",
    34: "Japan",
    35: "Saint Kitts and Nevis",
    36: "Niger",
    37: "Peru",
    38: "Portugal",
    39: "El Salvador",
    40: "Turkey",
    41: "Ukraine",
    42: "Uganda",
    43: "Wales",
    44: "Zambia",
    45: "Albania",
    46: "Argentina",
    47: "Azerbaijan",
    48: "Bahrain",
    49: "Congo DR",
    50: "Cote d'Ivoire",
    51: "China",
    52: "Costa Rica",
    53: "Faroe Islands",
    54: "Greece",
    55: "Guinea-Bissau",
    56: "Honduras",
    57: "Hungary",
    58: "Iraq",
    59: "Kenya",
    60: "Korea, Republic of",
    61: "Kazakhstan",
    62: "Liberia",
    63: "Malta",
    64: "Netherlands",
    65: "Northern Ireland",
    66: "Panama",
    67: "French Polynesia",
    68: "Paraguay",
    69: "Vietnam",
    70: "South Africa",
    71: "Bulgaria",
    72: "Brazil",
    73: "Belarus",
    74: "Central African Republic",
    75: "Cyprus",
    76: "Spain",
    77: "Grenada",
    78: "Korea DPR",
    79: "Luxembourg",
    80: "North Macedonia",
    81: "Serbia",
    82: "Saudi Arabia",
    83: "Solomon Islands",
    84: "Tanzania",
    85: "Uruguay",
    86: "United Arab Emirates",
    87: "Bolivia",
    88: "Chile",
    89: "France",
    90: "Gabon",
    91: "Guinea",
    92: "Iran",
    93: "Italy",
    94: "Jamaica",
    95: "Morocco",
    96: "Mozambique",
    97: "Rwanda",
    98: "Sweden",
    99: "Slovenia",
    100: "Sierra Leone",
    101: "Syria",
    102: "Scotland",
    103: "Turks and Caicos Islands",
    104: "Thailand",
    105: "Zimbabwe",
    106: "AN",
    107: "Benin",
    108: "Bermuda",
    109: "Canada",
    110: "Cameroon",
    111: "Colombia",
    112: "Algeria",
    113: "Ecuador",
    114: "Ghana",
    115: "Republic of Ireland",
    116: "Israel",
    117: "Lebanon",
    118: "Mexico",
    120: "Qatar",
    121: "Romania",
    122: "Sudan",
    123: "Slovakia",
    124: "San Marino",
    125: "Turkmenistan",
    126: "Trinidad and Tobago",
    127: "United States",
    128: "Andorra",
    129: "Armenia",
    130: "Australia",
    131: "Cape Verde",
    132: "Germany",
    133: "Denmark",
    134: "England",
    135: "Georgia",
    136: "Gambia",
    137: "Guatemala",
    138: "Iceland",
    139: "Jordan",
    140: "Kuwait",
    141: "Latvia",
    142: "Monaco",
    143: "Madagascar",
    144: "Namibia",
    145: "Russia",
    146: "Singapore",
    147: "Suriname",
    148: "Togo",
    149: "Uzbekistan",
    202: "Afghanistan",
    203: "Antigua and Barbuda",
    204: "Anguilla",
    209: "Antarctica",
    211: "American Samoa",
    214: "Aruba",
    215: "Aland Islands",
    218: "Barbados",
    219: "Bangladesh",
    226: "Saint Barthelemy",
    228: "Brunei Darussalam",
    231: "Bahamas",
    232: "Bhutan",
    233: "Bouvet Island",
    234: "Botswana",
    236: "Belize",
    238: "Cocos (Keeling) Islands",
    244: "Cook Islands",
    252: "Christmas Island",
    256: "Djibouti",
    258: "Dominica",
    259: "Dominican Republic",
    264: "Western Sahara",
    265: "Eritrea",
    267: "Ethiopia",
    269: "Fiji",
    270: "Falkland Islands (Malvinas)",
    271: "Micronesia, Federated States of",
    275: "United Kingdom",
    278: "French Guiana",
    279: "Guernsey",
    281: "Gibraltar",
    282: "Greenland",
    286: "Equatorial Guinea",
    288: "South Georgia and the South Sandwich Islands",
    290: "Guam",
    292: "Guyana",
    293: "Hong Kong",
    294: "Heard Island and McDonald Islands",
    299: "Indonesia",
    302: "Isle of Man",
    303: "India",
    304: "British Indian Ocean Territory",
    309: "Jersey",
    314: "Kyrgyzstan",
    315: "Cambodia",
    316: "Kiribati",
    317: "Comoros",
    322: "Cayman Islands",
    326: "Saint Lucia",
    328: "Sri Lanka",
    330: "Lesotho",
    334: "Libya",
    339: "Saint Martin (French part)",
    341: "Marshall Islands",
    344: "Myanmar",
    345: "Mongolia",
    346: "Macao",
    347: "Northern Mariana Islands",
    348: "Martinique",
    349: "Mauritania",
    350: "Montserrat",
    352: "Mauritius",
    353: "Maldives",
    356: "Malaysia",
    359: "New Caledonia",
    361: "Norfolk Island",
    363: "Nicaragua",
    366: "Nepal",
    367: "Nauru",
    368: "Niue",
    374: "Papua New Guinea",
    376: "Pakistan",
    378: "Saint Pierre and Miquelon",
    379: "Pitcairn",
    380: "Puerto Rico",
    383: "Palau",
    386: "Réunion",
    393: "Seychelles",
    397: "Saint Helena",
    399: "Svalbard and Jan Mayen",
    404: "Somalia",
    406: "Sao Tome and Principe",
    409: "Swaziland",
    411: "Chad",
    412: "French Southern Territories",
    415: "Tajikistan",
    416: "Tokelau",
    417: "Timor-Leste",
    420: "Tonga",
    423: "Tuvalu",
    424: "Taiwan, Province of China",
    428: "United States Minor Outlying Islands",
    432: "Holy See (Vatican City State)",
    433: "Saint Vincent and the Grenadines",
    435: "Virgin Islands, British",
    436: "Virgin Islands, U.S.",
    438: "Vanuatu",
    439: "Wallis and Futuna",
    440: "Samoa",
    441: "Yemen",
    442: "Mayotte",
    444: "Netherlands Antilles",
    446: "Soviet Union",
    447: "CSSR",
    448: "Yugoslavia",
    450: "Fantasy League",
    452: "DDR",
    455: "Tahiti",
    457: "Kosovo",
    461: "Curaçao",
    462: "South Sudan",
}
